var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"menu-button",on:{"click":_vm.addVideo}},[_c('app-icon',{staticClass:"h-5 w-5",attrs:{"name":"video-stroke"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }